 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TITLEPAGE from '@/components/title-page'
 import EBOOKCOPYRIGHT from '@/components/ebook-copyright'
 import PRINTCOPYRIGHT from '@/components/print-copyright'
 import CONTENTS from '@/components/contents'
 import INTRODUCTION from '@/components/introduction'
 import YOULLNEVERHAVEREVIVALBECAUSE from '@/components/youll-never-have-revival-because'
 import YOULLNEVERHAVEREVIVALBECAUSE2 from '@/components/youll-never-have-revival-because-2'
 import YOULLNEVERHAVEREVIVALBECAUSE3 from '@/components/youll-never-have-revival-because-3'
 import YOULLNEVERHAVEREVIVALBECAUSE4 from '@/components/youll-never-have-revival-because-4'
 import YOULLNEVERHAVEREVIVALBECAUSE5 from '@/components/youll-never-have-revival-because-5'
 import YOULLNEVERHAVEREVIVALBECAUSE6 from '@/components/youll-never-have-revival-because-6'
 import YOULLNEVERHAVEREVIVALBECAUSE7 from '@/components/youll-never-have-revival-because-7'
 import AFTERWORD from '@/components/afterword'
 import BEFOREYOUGO from '@/components/before-you-go'
 import ALSOFROMREVIVALTODAY from '@/components/also-from-revival-today'
 import AUTHORPHOTO from '@/components/author-photo'
 import FULLPAGEIMAGE from '@/components/full-page-image'
 import ABOUTTHEAUTHOR from '@/components/about-the-author'
 import FULLPAGEIMAGE2 from '@/components/full-page-image-2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/title-page",
 			"name" : "title-page",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/ebook-copyright",
 			"name" : "ebook-copyright",
 			"component" : EBOOKCOPYRIGHT
 		},
 		{
 			"path" : "/print-copyright",
 			"name" : "print-copyright",
 			"component" : PRINTCOPYRIGHT
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js